// extracted by mini-css-extract-plugin
export default {"Error":"style_Error__41f2k"};